import React from 'react';
import Panel from 'muicss/lib/react/panel';
import Button from 'muicss/lib/react/button';
import Container from 'muicss/lib/react/container';
import Row from 'muicss/lib/react/row';
import Col from 'muicss/lib/react/col';
import AddToFavorites from './AddToFavorites';

import {browserHistory} from 'react-router';

//import BreweryDetail from './BreweryDetail';


class Brewery extends React.Component {

    constructor(props) {
    super(props);
     this.state = {
      detailsClicked: false,
      detailsText:'Details'
    };

    this.goToBreweryRoute = this.goToBreweryRoute.bind(this);
    this.onVisitSiteClick = this.onVisitSiteClick.bind(this);
    this.goToBreweryRoute = this.goToBreweryRoute.bind(this);
  }


    onVisitSiteClick() {
        //console.log('visit the site'+ this.props.details.linkd);
        var win = window.open(this.props.details.linkd, '_blank');
        win.focus();
    }

    goToBrewery() {
        this.setState({detailsClicked: !this.state.detailsClicked});
        if (!this.state.detailsClicked) {
            this.setState({detailsText: 'Hide details'});
        }else {
            this.setState({detailsText: 'Details'});
        }
    }

    goToBreweryRoute() {
        //var storeID = this.refs.storeId.value;
        var breweryId = this.props.index;
        //console.log(this.props.key);
        browserHistory.push('/brewery/'+breweryId);
        //this.history.pushState(null, '/brewery/'+breweryId);
    }

    render() {
        var details = this.props.details;
        //let detailClick = this.gotoBrewery.bind(this, {details.name});
        return (
            <div>
            <Panel>
            <Container fluid={true}>
            <Row>
            <Col xs="12" md="7">
           
            <AddToFavorites className="brewery" brewery={details.name}/>
            <h2>{details.name}</h2>
            
            <span> {details.address}</span>
           
            </Col>
            <Col xs="6" md="5">
            <Row>
            <Col xs="12" md="6">
            <Button variant="raised" color="primary" onClick={this.onVisitSiteClick}>Website</Button>
            </Col>
            <Col xs="12" md="6">
            <Button variant="raised" color="primary" onClick={this.goToBreweryRoute}>Details</Button>
            </Col>
            </Row>
            </Col>
            
            </Row>
            <Row>
            <Col xs="12" md="12">
            </Col>
            </Row>
          
            </Container>
            </Panel>
            
           
            </div>
        )
    }

};

export default Brewery;


/** WEBPACK FOOTER **
 ** ./src/Brewery.js
 **/